export default __webpack_public_path__ + "static/media/badge-icon.6264900c.svg";